<template>
	<div>
		  <Breadcrumbs main="Technicians" title="Update Technician" />
			 <div class="container-fluid">
				<div class="row">
				   <div class="col-sm-12">
					  <div class="card">
						 <div class="card-body">
 
							<div class="row mb-3">
							   	<div class="col-12">
									<a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>
							   	</div>
							</div>
 
							<form  @submit.prevent="updateStaff" enctype="multipart/form-data">
								<div class="form theme-form">
									<div class="row">
										<div class="col-md-4">
											<div class="mb-3">
												<label class="control-label">Staff Name<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="" v-model="staff.name"/>
											</div>
										</div>

										<!--<div class="col-md-4">
											<div class="mb-3">
												<label class="control-label">Type<span class="text-danger">*</span></label>
												<select class="form-select" v-model="staff.staff.staff_type">
													<option value="">Choose Staff Type</option>
													<option value="1">Manufacturing</option>
													<option value="2">Operational & Accounts</option>
												</select>
											</div>
										</div>-->

                                        <div class="col-md-4 form-group">
                                            <label class="control-label">Mobile No.<span class="text-danger">*</span></label>
                                            <input class="form-control" placeholder="" v-model="staff.mobile" v-mobile-limit maxlength="10" minlength="10" />
                                        </div>
									
										<div class="col-md-4">
											<div class="mb-3">
												<label class="control-label">Email<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="" v-model="staff.email"/>
											</div>
										</div>

									</div>

									<div class="row mt-3">
										<div class="col-sm-12">
											<button class="btn btn-success me-2 float-end" type="submit" :disabled="submitting">
												<span v-if="submitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
												{{ submitting ? "Saving..." : "Save" }}
											</button>
										</div>
									</div>
	
								</div>
							</form>
						 </div>
					  </div>
				   </div>
				</div>
			 </div>
 
	</div>
 </template>

<script>
	export default {
		name: "Add Campaign Page",
		

		data() {
			return {
				
				keyword: "",
				showsearch: false,
				listing_length: 10,
				token: "",
				submitting: false,
				errors: {},

				button_title: "Save",

				staff: {
					name: "",
					email: "",
					mobile: "",
					staff: {
						staff_type: ""
					}
				}

			};
		},
		created() {

			this.staffDetail();

		},
		
		methods: {

			getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},

			staffDetail(page_url = null) {
				this.getToken();
				let url = '/staffs/staffDetail?staff_id=' + this.$route.params.id;
				page_url = page_url || url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.staff = responseData.staff;
					})
					.catch((err) => console.log(err));
			},

			updateStaff() {
				if (this.submitting) return;
				this.submitting = true;
				this.getToken();

				const config = {
					headers: {
					"Content-type": "multipart/form-data",
					Accept: "application/json",
					Authorization: "Bearer " + this.token,
					},
				};

				let url = "staffs/updateStaff";
				{
					{
					this.token;
					}
				}
				let formData = new FormData();
				formData.append("staff_id", this.$route.params.id);
				formData.append("name", this.staff.name);
                formData.append("mobile", this.staff.mobile);
                formData.append("email", this.staff.email);

				this.$axios
					.post(url, formData, config)
					.then((response) => {
					if (response.data.status) {
						this.$swal("", response.data.message, "success");
					} else {
						this.$swal("", response.data.message, "error");
					}
					this.$router.push({ path: '/staffs' })
					})
					.catch((error) => {
						console.log(error);
						console.log(error.response);
						if (error.response) {
							if (error.response.data.message) {
								this.errors = error.response.data.message;
								this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					})
					.finally(() => {
						this.submitting = false;
					});
        	},

		},
	};

</script>